<template>
  <main class="results page" v-if="dataLoaded" :class="results.length != 0 ? '' : 'no-results'">
    <section  v-if="results.length != 0" class="results-content mainContent">
      <sectionHeader/>
      <h1>Résultats</h1>
       <countrySelector/>
     <!-- <resultsJobsList @updateIndex="updateIndex" :initActiveJob="index"/>--> 
      <resultsJobsList @updateIndex="updateIndex" :initActiveJob="firstJobIndex"/>
      <resetBtn/>
    </section >

    <section  class="no-results-content mainContent" v-else>
      <sectionHeader/>
      <h1>Résultats</h1>

        <article class="job-description">
          Aucun résultats ne semble correspondre...
        </article>
      <resetBtn/>
    </section>

    <section class="job-section" v-if="results.length != 0">
      <article class="job-description">
       <!-- <div class="scroll-text-wrapper" data-simplebar > -->
         <section class="job-section-media">

            <video v-if="results.length != 0 && jobs[index].video" class="job-video" ref="videoRef" :key="index" controls>
              <source :src="jobs[index].video" type="video/mp4">
            </video>

            <div v-else class="mobile-img job-image">
              <img v-if="results.length != 0 && jobs[index].img " :src="jobs[index].img" :key="index"/>
              <img v-else :src="details.intro_image"/>
            </div>
          </section>

          <header class="job-section-header">
            <div class="job-header">
               <h2 class="job-title">
                {{ selectedCountry === 'fr' && jobs[index].metier_fr ? jobs[index].metier_fr : jobs[index].metier }}
              </h2>
               <!-- Nouveau bouton Cité des Métiers - CORRIGÉ -->
            </div>

            <nav class="jobs-description-nav">
              
              <div class="btn btn-description" :class="{active:!showCursus }" v-on:click="fnShowDescription" >Description <vue-feather type="arrow-right" size="30"></vue-feather></div>
              
              <!-- Bouton Cursus (contenu existant) -->
              <div v-if="selectedCountry === 'ch' && jobs[index].cursus && !jobs[index].cursus_ch" class="btn btn-cursus" :class="{active:showCursus}" v-on:click="fnShowCursus">Cursus 🇨🇭<vue-feather type="arrow-right" size="30"></vue-feather></div>

              <!-- Bouton Cursus Français -->
              <a v-if="selectedCountry === 'fr' && jobs[index].cursus_fr" :href="jobs[index].cursus_fr" target="_blank" class="btn btn-cursus btn-cursus-fr">Cursus sur O'rêka<vue-feather type="external-link" size="15"></vue-feather></a>

              <!-- Cursus Suisse remplace le lien "En savoir plus" -->
              <a v-if="selectedCountry === 'ch' && jobs[index].cursus_ch" :href="jobs[index].cursus_ch" target="_blank" class="btn btn-cursus btn-cursus-ch">Cursus sur Orientation.ch<vue-feather type="external-link" size="15"></vue-feather></a>
              
              <!-- Lien cité des métiers si disponible-->
              <a v-if="selectedCountry === 'ch' && currentCiteMetier && currentCiteMetier.exhibitors && currentCiteMetier.exhibitors.length > 0 && currentCiteMetier.exhibitors[0].url" class="btn btn-cursus btn-cdm" :href="currentCiteMetier.exhibitors[0].url" target="_blank">Cité des Métiers<vue-feather type="external-link" size="15"></vue-feather></a>
            </nav>

            <p v-if="selectedCountry === 'ch' && currentCiteMetier && currentCiteMetier.exhibitors && currentCiteMetier.exhibitors.length > 0 && currentCiteMetier.exhibitors[0].url" :href="currentCiteMetier.exhibitors[0].url" class="cdm-stand-link">
               Ce métier est présenté à la Cité des Métiers : retrouvez-le sur le stand <a :href="currentCiteMetier.exhibitors[0].url" target="_blank">{{ currentCiteMetier.exhibitors[0].name }} </a>
              </p>
          </header>

          <div v-if="showCursus===false" class="content description-content" v-html="jobs[index].description"></div>
          <div v-else class="content cursus-content" v-html="jobs[index].cursus"></div>
       <!-- </div> -->
      </article>

    </section>
  </main>
</template>

<script>
import sectionHeader from '@/components/sectionHeader.vue'
import resultsJobsList from '@/components/results/resultsJobsList.vue'
import resetBtn from '@/components/reset.vue'
import countrySelector from '@/components/countrySelector.vue'  
import axios from 'axios'
import { mixins } from '../mixins/mixins.js'

export default {
  name: 'Results',
  mixins: [mixins],
  components: {
    sectionHeader,
    resultsJobsList,
    countrySelector,
    resetBtn
  },
  data () {
    return {
      index: 0,
      contentTitle: 'Description du métier',
      btnLabel: 'Cursus',
      showCursus: false,
      parameters: [],
      dataLoaded: false,
      usersResults: null,
      citeMetiersCareers: [] // Ajouter cette données manquante
    }
  },

  computed: {
    jobs () {
      return this.$store.state.jobs
    },
    quizResults () {
      return this.$store.state.userResponses
    },
    details () {
      return this.$store.state.details
    },
    results () {
      return this.$store.state.results
    },
    selectedCountry () {
      return this.$store.state.selectedCountry
    },
          // Computed pour trouver le métier correspondant
    currentCiteMetier () {
      if (!this.jobs[this.index] || !this.jobs[this.index].cursus_ch || !this.citeMetiersCareers.length) {
        return null
      }
      
      const cursusChUrl = this.jobs[this.index].cursus_ch
      
      // Fonction pour extraire l'ID du métier depuis l'URL
      const extractIdFromUrl = (url) => {
        const match = url.match(/[?&]id=(\d+)/);
        return match ? match[1] : null;
      }
      
      const cursusId = extractIdFromUrl(cursusChUrl)
      
      if (!cursusId) {
        return null
      }
      
      const found = this.citeMetiersCareers.find(career => {
        if (!career.orch_url) return false
        
        const careerIdMatch = extractIdFromUrl(career.orch_url)
        return careerIdMatch === cursusId
      })
      
      return found
    },
    firstJobIndex () {
      return this.results.length > 0 ? this.results[0].jobIndex : 0
    },
  },

  methods: {
    updateIndex (variable) {
      this.index = variable
    },
    toggleCursus () {
      if (this.showCursus === false) {
        this.showCursus = true
        this.contentTitle = 'Cursus'
        this.btnLabel = 'Description'
      } else {
        this.contentTitle = 'Description du métier'
        this.showCursus = false
        this.btnLabel = 'Cursus'
      }
      console.log(this.showCursus)
    },
    fnShowCursus () {
      this.showCursus = true
      this.contentTitle = 'Cursus'
    },
    fnShowDescription () {
      this.showCursus = false
      this.contentTitle = 'Description du métier'
    },
    // Méthode pour récupérer les données de l'API Cité des Métiers
      // Méthode pour récupérer les données de l'API Cité des Métiers
    async fetchCiteMetiersCareers () {
      try {
        const response = await axios.get('https://cite-metiers.ch/api/careers')
        this.citeMetiersCareers = response.data.data || []
      } catch (error) {
        console.error('Erreur lors de la récupération des données Cité des Métiers:', error)
        this.citeMetiersCareers = []
      }
    }
  },

    async mounted () {
    // Récupérer les données de l'API Cité des Métiers
    await this.fetchCiteMetiersCareers()

    // récupérer le paramaètre ID
    const urlParams = new URLSearchParams(window.location.search)
    this.parameters = ''
    this.parameters = urlParams.get('entry_id')
    if (!this.parameters) {
      this.dataLoaded = true
      // Le premier résultat est maintenant automatiquement le meilleur
      this.$nextTick(() => {
        if (this.results.length > 0) {
          this.index = this.results[0].jobIndex
        }
      })
    } else {
      axios.get(
        this.$store.state.sourceUrl + '/wp-json/wp/v2/entree/' + this.parameters,
        {
          // withCredentials: true,
          auth: {
            username: 'jerome',
            password: 'gG1t 6T8m tmL9 UzBS fAEO gpgx'
          }
        })
        .then(response => {
          this.usersResults = response.data
          console.log('resultats obtenus')
          console.log(this.usersResults)
          this.$store.state.results = this.usersResults.acf.resultat
          this.dataLoaded = true
          // Mettre à jour l'index après le chargement des résultats
          this.$nextTick(() => {
            if (this.results.length > 0) {
              this.index = this.results[0].jobIndex
            }
          })
        })
        .catch(error => {
          console.log('Bad news with the datas')
          console.log(error)
        })
    }
  },

  watch: {
   index () {
      const video = this.$refs.videoRef
      if (video && !video.paused) {
        video.pause()
        video.currentTime = 0
      }
    },
    // Ajouter ce watch pour s'assurer que l'index est initialisé
    dataLoaded (newVal) {
      if (newVal && this.results.length > 0 && this.index === 0) {
        this.$nextTick(() => {
          this.index = this.results[0].jobIndex
          console.log('Index initialisé à:', this.index, 'pour le métier:', this.jobs[this.index]?.metier)
        })
      }
    }
  }
}
</script>

<style lang="scss">

  main.results.no-results {
    grid-template-columns:1fr 0fr;
  }
  main.results {
    grid-template-columns: 3fr 4fr;
    column-gap: 20px;
    @media all and (min-width: 1366px) {
        grid-template-columns: 2fr 4fr;
        column-gap: 40px;
      }
    .country-selector {
      margin-top: 30px;
    } 
    .results-content {

      padding: 15px 0px 40px 40px;
      @media all and (max-width: 768px) {
        padding: 0px 40px 40px 40px;
        justify-content: flex-start;
        align-items: flex-start;
      }
    }
    .results-content .section-header {
      margin-bottom: 70px;
    }

    .no-results-content .section-header {
      margin-bottom: 32vh;
    }
  }

  .results-content  {
     @media all and (max-width: 1366px) {

      h1 {
        font-size: 50px;
      }
      .quiz_title {
    
      }

      @media all and (max-width: 540px) {
        h1 {
          text-align: left;
          width: 100%;
        }
      }
    }
    .reset-btn{
      margin-top: 0;
      font-size: 15px;
    }
  }

  .mobile-img {
    margin-top: 0;
    margin-bottom: 30px;

    &.job-image {
      height: 300px;
      @media all and (min-width: 769px) {
        height: 400px;
        display: block;
      }
    }
  }

  .scroll-text-wrapper {
      height: auto;
      @media all and (min-width: 769px) {
        height: calc(100vh - 80px);
        padding-right: 40px;
      } 
    }

  .job-section {
    padding: 40px;
  }
  .job-description {
    width: 100%;
    max-width: 1200px;
    font-size: 20px;

    .job-video {
      width: 100%;
      height: auto;
      margin-top: 0;
      margin-bottom: 30px;
      object-fit: cover;
    }

    .job-section-header {
      margin-bottom: 30px;
      align-items: center;

      .job-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;

        .job-title {
          width: 70%;
          margin-right: auto;
          text-align: left;
          margin: 0 0 auto 0;
          line-height: 1.2;
          // min-height: 80px;

          @media all and (max-width: 768px) {
            font-size: 28px;
          }

          @media all and (max-width: 540px) {
            font-size: 20px;
          }
        }
      }

      .jobs-description-nav {
        display: flex;
        gap: 15px;
        flex-wrap: wrap;
        // justify-content: space-between;

        .btn-description,
        .btn-cursus {
          vertical-align: middle;
          font-size: 15px;
          border-width: 1px;
          transition: all 0.3s;
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 5px 16px;

          @media all and (max-width: 768px) {
            font-size: 16px;
          }

          &.active {
            background-color: #000;
            color: #fff;
          }

          .vue-feather--arrow-right {
            display: inline-block;
            width: 0;
            overflow: hidden;
            //font-size: 30px;
            vertical-align: middle;
            transition: margin 0.3s;
          }

          &.active,
          &:hover {
            .vue-feather--arrow-right {
              width: 20px;
              margin-left: 8px;
            }
          }
        }
        .btn-cdm {
          @media all and (max-width:1146px) and (min-width: 768px) {
            flex-wrap: wrap;
          }
        }

        .orientation-link {
          margin-left: auto;
          font-size: 16px;
          color: #000;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    .cdm-stand-link {
      margin-bottom: 15px;
      font-size: 16px;

      a {
        color: #000;
        text-decoration: underline;
      }
    }

    .content {
      text-align: left;
      font-size: 16px;

      b, strong {
        font-weight: 600;
      }
      a {
        color: #000;
      }
      @media all and (max-width: 768px) {
        font-size: 16px;
        padding-right: 0;

        ul, li {
          padding-right: 0;

        }
      }
      @media all and (max-width: 540px) {
        font-size: 16px;
      }

      table {
        width: 100%;
        border-spacing: 0;

        @media all and (max-width: 768px) {
          font-size: 18px !important;
        }
        @media all and (max-width: 540px) {
          font-size: 16px !important;
        }
      }

      ul {
        padding-left: 18px;
      }
    }
  }
</style>
